export interface IImportTemplateFormInput {
	description: string;
	id: string;
}

export const emptyImportTemplateForm: IImportTemplateFormInput = {
	description: "",
	id: "",
};
